import { render } from "./ResourceIndex.vue?vue&type=template&id=4a4ea0d0"
import script from "./ResourceIndex.vue?vue&type=script&lang=js"
export * from "./ResourceIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__